import { Market } from '../../types/shared/Market';
import { VendorList } from '../../types/shared/Vendor';
import {
  PlacementByVendor,
  VendorPlacementByIndex,
} from '../../types/shared/Placement';

export default function getVendorPlacement(
  market: Market | null | undefined,
  date: string | null | undefined,
  options: {
    vendors: VendorList | null | undefined;
    placement: PlacementByVendor | null | undefined;
  },
): VendorPlacementByIndex {
  let placementByIndex: VendorPlacementByIndex = {};
  let { vendors, placement } = options;
  if (!market || !vendors || !placement) {
    return placementByIndex;
  }
  if (!date) {
    date = market.dates[0];
  }
  if (!date) {
    return placementByIndex;
  }
  for (let vendorID of Object.keys(placement)) {
    let vendor = vendors.getByID(vendorID);
    if (
      !vendor ||
      !vendor.markets ||
      !vendor.markets[market.id] ||
      vendor.markets?.[market.id]?.indexOf(date) === -1
    ) {
      continue;
    }
    let vendorMarkets = placement[vendorID] || {};
    let vendorDates = vendorMarkets[market.id] || {};
    let placementIndexes = vendorDates[date] || [];
    for (let index of placementIndexes) {
      placementByIndex[index] = vendor;
    }
  }
  return placementByIndex;
}
